import api from "../api/api";
import { appState, dispatch } from "../redux/redux-config";
import navigate from "../utilities/navigation";
import { isInstalled } from "../utilities/utilities";
import { showToast } from "../components/toast";

const user = {
  login: async (username, password) => {
    dispatch("LOGIN_STARTED", true);

    let installed = isInstalled() || undefined;

    let result = await api.authentication.login(username, password, installed);

    if (result.success) {
      dispatch("LOAD_USER", result);
      if (installed) localStorage.setItem("session", result.jwt);
      else sessionStorage.setItem("session", result.jwt);
    } else {
      dispatch("LOGIN_ERROR", result);
    }
  },

  getUserInfo: async () => {
    let user = appState().user;
    if (user.loaded === undefined && user.token) {
      dispatch("LOAD_USER_INFO", { loaded: false });

      let result = await api.user.getUserInfo(user.token);
      if (result.success) {
        result.loaded = true;
        dispatch("LOAD_USER_INFO", result);
        if (result?.read_only) {
          showToast(
            "info",
            "Your dashboard is view-only by your organization’s policy."
          );
        }
      } else {
        dispatch("LOGIN_ERROR", result);
      }
    }
  },

  getUserCount: async () => {
    let token = appState().user.token;
    let result = await api.user.getUserCount(token);
    return result.count || "-";
  },

  setupPassword: async function (token, password) {
    return await api.authentication.setupPassword(token, password);
  },

  getShortTermToken: async function () {
    let token = appState().user.token;
    let result = await api.authentication.getShortTermToken(token);
    if (result.success) return result.token;
  },

  logout: function () {
    sessionStorage.removeItem("session");
    sessionStorage.removeItem("unitySessionKey");
    localStorage.removeItem("session");
    localStorage.removeItem("unitySessionKey");
    dispatch("LOGOUT");
  },

  loadUserTypes: function () {
    let state = appState().user;
    if (!state.token) return null;
    if (state.userTypeOptions) return state.userTypeOptions;
    state.sync.loadingUserTypes = true;

    api.user.getUserTypes(state.token).then((result) => {
      if (result.success) {
        // state.sync.loadingGroupOptions = false;
        dispatch("USER_SETTINGS", {
          userTypeOptions: result.list.map((g) => ({
            value: g.id,
            label: g.name,
          })),
        });
      }
    });

    return null;
  },

  getRecentMessages: async function (messageType, getOnlyUnreadMessages) {
    let token = appState().user.token;
    let result = await api.user.getRecentMessages(
      token,
      messageType,
      getOnlyUnreadMessages
    );
    if (result.success) {
      return result;
    }
  },
  getRecentMessagesForSpecificUser: async function (messageType, getOnlyUnreadMessages, userId) {
    let token = appState().user.token;
    let result = await api.user.getRecentMessagesForSpecificUser(
      token,
      messageType,
      getOnlyUnreadMessages,
      userId
    );
    if (result.success) {
      return result;
    }
  },

  getMessagePreview: async function (alertId) {
    let token = appState().user.token;
    let result = await api.user.getMessagePreview(token, alertId);
    if (result.success) {
      return result;
    }
  },
  getSpecificUserDetails: async function () {
    let token = appState().user.token;
    let result = await api.user.getSpecificUserDetails(token);
    if (result.success) {
      return result;
    }
  },
  getSpecificDetailForSpecificUser: async function (userId) {
    let token = appState().user.token;
    let result = await api.user.getSpecificDetailForSpecificUser(token, userId);
    if (result.success) {
      return result;
    }
  },
  updateUserProfile: async function (payload) {
    let token = appState().user.token;
    let result = await api.user.updateUserProfile(token, payload);
    if (result.success) {
      return result;
    }
  },
  updateUserProfileForSpecificUser: async function (payload, userId) {
    let token = appState().user.token;
    let result = await api.user.updateUserProfileForSpecificUser(token, payload, userId);
    if (result.success) {
      return result;
    }
  },
  updatePreference: async function (payload) {
    let token = appState().user.token;
    let result = await api.user.updatePreference(token, payload);
    if (result.success) {
      return result;
    }
  },
  updatePreferenceForSpecificUser: function (payload, userId) {
    let token = appState().user.token;
    return api.user.updatePreferenceForSpecificUser(token, payload, userId);
  },
  updateReadMessageProperty: async function (payload) {
    let token = appState().user.token;
    let result = await api.user.updateReadMessageProperty(token, payload);
    if (result.success) {
      return result;
    }
  },
  getAlertCredit: async function () {
    let token = appState().user.token;
    let result = await api.user.getAlertCredit(token);
    if (result.success) {
      return result;
    }
  },

  getEmailCredit: async function () {
    let token = appState().user.token;
    let result = await api.user.getEmailCredit(token);
    if (result.success) {
      return result;
    }
  },

  amplifyLogin: async function (payload) {
    let result = await api.user.amplifyLogin(payload);
    return result;
  },

  uploadProfilePhoto: async function (payload) {
    let token = appState().user.token;
    let result = await api.user.uploadProfilePhoto(token, payload);
    return result;
  },
  uploadProfilePhotoForSpecificUser: async function (payload, userId) {
    let token = appState().user.token;
    let result = await api.user.uploadProfilePhotoForSpecificUser(token, payload, userId);
    return result;
  },
  getUserTypeDropdown: async function () {
    let token = appState().user.token;
    let result = await api.user.getUserTypeDropdown(token);
    if (result.success) {
      return result;
    }
  },
  getUserProduct: async function () {
    let token = appState().user.token;
    let result = await api.user.getUserProduct(token);
    if (result.success) {
      return result;
    }
  }
};
export default user;
export async function ValidateUnitySession(sessionKey) {
  let result = await api.user.ValidateUnitySession(sessionKey);
  return result;
}
export function userReducer(state, action) {
  if (state === undefined) return initialState;

  //if (action.type.indexOf("@@") !== 0) {
  //    console.log(action)
  //}

  switch (action.type) {
    case "LOGIN_STARTED":
      return {
        ...state,
        loggingIn: action.payload,
      };

    case "LOAD_USER":
      return {
        ...state,
        token: action.payload.jwt,
        loggingIn: false,
        resetId: undefined,
      };

    case "LOAD_USER_INFO":
      return {
        ...state,
        loaded: true,
        ...action.payload,
      };

    case "LOGIN_ERROR":
      return {
        ...state,
        loggingIn: false,
      };

    case "LOGIN_SETTINGS":
    case "USER_SETTINGS":
      return {
        ...state,
        ...action.payload,
      };

    case "SWITCH_LOGIN_SCREEN":
      return {
        ...state,
        switchLoginScreen: action.payload,
      };

    case "LOGOUT":
      return {
        ...initialState,
        switchLoginScreen: "login",
        token: null,
      };

    default:
      return state;
  }
}

const initialState = {
  token: isInstalled()
    ? localStorage.getItem("session")
    : sessionStorage.getItem("session"),
  loaded: undefined,
  switchLoginScreen:
    window.location.pathname === "/reset" ? "resetPassword" : "login",
  sync: {},
};
